import React, { useState } from "react";
import { Box, Chip, Input as JoyInput } from "@mui/joy";
import { useController } from "react-hook-form";
import { Icon } from "src/mtska-frontend-app-component/assets";

const InputChip = ({ name, control, label, options, type, editing, ...rest }) => {
  const {
    field: { onChange, value },
  } = useController({ name, control });

  const [isEditing, setIsEditing] = useState(!value);

  const selectedOption = options?.find((option) => option.value === value);

  const handleChipClick = () => {
    setIsEditing(true);
  };

  const handleBlur = (event) => {
    if (event.target.value) {
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <JoyInput
        {...rest}
        type={type}
        name={name}
        value={value}
        onChange={(event) => {
          onChange(event);
          if (type !== 'text') {
            setIsEditing(false);
          }
        }}
        onBlur={handleBlur}
        placeholder={label}
        editing={editing}
      />
    );
  }

  return (
    <Box onClick={handleChipClick} sx={{ cursor: 'pointer', p: 1, border: '1px solid #ccc', borderRadius: '4px' }}>
      <Chip
        variant="soft"
        color="primary"
        endDecorator={
          <Box onClick={(e) => {
            e.stopPropagation();
            onChange('');
            setIsEditing(true);
          }}>
            <Icon icon="faTimes" />
          </Box>
        }
      >
        {selectedOption ? selectedOption.label : value}
      </Chip>
    </Box>
  );
};

export default InputChip;